export default {
  name: "FooterSection",
  data(){
    return({
      rights:{
        company_name: "EPF VSI Perpetual Social",
        year: new Date().getFullYear()
      }
    })
  }
};
